import { render, staticRenderFns } from "./internetTelephone.vue?vue&type=template&id=640f55df&scoped=true"
import script from "./internetTelephone.vue?vue&type=script&lang=js"
export * from "./internetTelephone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f55df",
  null
  
)

export default component.exports